import { PositionHoof } from 'models'

export const hoofLabels = {
	[PositionHoof.Front_Left]: 'Переднее левое',
	[PositionHoof.Front_Right]: 'Переднее правое',
	[PositionHoof.Rear_Left]: 'Заднее левое',
	[PositionHoof.Rear_Right]: 'Заднее правое',
	[PositionHoof.All]: 'Все копыта',
}
